<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="我的球杆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <!-- 新增：添加新球杆按钮 -->
      <div class="add-club-btn-wrapper">
        <van-button
            class="add-club-btn"
            type="primary"
            size="large"
            icon="plus"
            @click="onAddClub"
        >
          添加新球杆
        </van-button>
      </div>
      <van-card
          shadow="never"
          class="my-card"
          v-for="club in clubList"
          :key="club.id">
        <template #desc>
          <!-- 序列号行：核心修改，包左对齐容器实现标签右对齐 -->
          <div class="info-item serial-item">
            <div class="label-value-wrap">
              <span class="label">球杆编码:</span>
              <span class="value value_xlh">{{ club.value }}</span>
            </div>
            <!-- 待绑定标签：单独右对齐 -->
            <van-tag class="bind-tag-red" v-if="club.bind ==='1'" >待绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='2'" >已绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='3'" >绑定失败</van-tag>
            <van-tag class="bind-tag-red" v-else>{{club.bind}}</van-tag>
          </div>
          <!-- 其他信息行：保持原有样式不变 -->
          <div class="info-item">
            <span class="label">品牌:</span>
            <span class="value value_xlh">{{ club.brand }}</span>
          </div>
          <div class="info-item">
            <span class="label">系列:</span>
            <span class="value value_xlh">{{ club.model }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品名称:</span>
            <span class="value value_xlh">{{ club.portalSpecs }}</span>
          </div>
          <div class="info-item  serial-item">
            <div class="label-value-wrap">
              <span class="label">销售商户:</span>
              <span class="value value_xlh">{{ club.agentName }}</span>
            </div>

            <!-- 待绑定标签：单独右对齐 -->
            <van-tag class="bind-tag" color="#D4AF37"  text-color="#000" v-if="club.bind ==='1'" @click="onBind(club.value )">去绑定</van-tag>
            <van-tag class="bind-tag" color="#D4AF37"  text-color="#000" v-if="club.bind ==='3'" @click="onBind(club.value )">重新绑定</van-tag>
          </div>
          <!-- 权益申请状态注释代码保持不变 -->
          <!--          <div class="info-item" v-if="club.businessId && (club.state == '1' || club.state == '2')">-->
          <!--            <span class="label">状态:</span>-->
          <!--            <span v-if="club.state == '1'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}审核中</span>-->
          <!--            <span v-if="club.state == '2'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}中</span>-->
          <!--          </div>-->
        </template>
      </van-card>

<!--      &lt;!&ndash; 新增：添加新球杆按钮 &ndash;&gt;-->
<!--      <div class="add-club-btn-wrapper">-->
<!--        <van-button-->
<!--            class="add-club-btn"-->
<!--            type="primary"-->
<!--            size="large"-->
<!--            icon="plus"-->
<!--            @click="onAddClub"-->
<!--        >-->
<!--          添加新球杆-->
<!--        </van-button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {benefitsByUser} from "@/api/sales";
import {Dialog, Tag, Button} from "vant"; // 新增：引入Button组件

export default {
  components: {
    VanTag: Tag,
    VanButton: Button // 新增：注册Button组件
  },
  data(){
    return {
      clubList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    // 新增：添加新球杆按钮点击事件（跳转到app_activation路由）
    onAddClub() {
      this.$router.push({
        path: '/app_activation' // 跳转到指定路由
      });
    },
    //跳转球杆绑定
    onBind(number){
      this.$router.push({
        path: '/app_activation',
        query: {
          number: number
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    selectProductByUser(){
      benefitsByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.clubList = res.data;
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
            // PC端弹窗适配
            style: { width: '90%', maxWidth: 'none' }
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '请稍后重试',
          // PC端弹窗适配
          style: { width: '90%', maxWidth: 'none' }
        });
      })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-card__content{
  @media (min-width: 768px) {
    min-height: 0;
  }
}
// 容器适配：沿用公共样式50%宽度，PC端增强视觉
.h5-container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000;
  padding-bottom: 40px;
  // PC端样式增强
  @media (min-width: 768px) {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    padding-bottom: 60px;
  }
}

// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
  // PC端放大返回箭头
  @media (min-width: 768px) {
    font-size: 24px;
  }
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
  // PC端放大返回文字
  @media (min-width: 768px) {
    font-size: 18px;
  }
}
::v-deep .van-nav-bar__title {
  // PC端放大标题
  @media (min-width: 768px) {
    font-size: 22px;
    font-weight: bold;
  }
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  // PC端增高导航栏
  @media (min-width: 768px) {
    height: 70px;
    line-height: 70px;
  }
}

// 主容器适配
.container-item {
  margin-bottom: 60px;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  // PC端调整间距
  @media (min-width: 768px) {
    margin-bottom: 80px;
    padding: 0 20px;
  }
}

// 球杆卡片适配
.my-card{
  margin: 15px;
  border-radius: 12px;
  background: #fff;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  // PC端卡片优化
  @media (min-width: 768px) {
    margin: 20px auto;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 100%;
  }

  // 保证卡片内边距统一，标签对齐无偏移
  ::v-deep .van-card__desc {
    padding: 0 !important;
    // PC端卡片内容区放大
    @media (min-width: 768px) {
      padding: 10px 0 !important;
    }
  }
  // PC端卡片头部样式
  ::v-deep .van-card__header {
    @media (min-width: 768px) {
      padding: 10px 0;
    }
  }
}

// 信息项基础样式
.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  width: 100%; // 撑满卡片宽度

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #0f0f0f;
    width: 80px;
    font-weight: 500;
  }

  .value {
    color: #0f0f0f;
    word-break: break-all;
  }

  // PC端信息项放大
  @media (min-width: 768px) {
    margin-bottom: 18px;
    font-size: 18px;

    .label {
      width: 100px;
      font-size: 18px;
      font-weight: bold;
    }

    .value {
      font-size: 18px;
      line-height: 1.6;
    }
  }
}

// 序列号行专属样式：两端对齐实现标签右对齐
.serial-item {
  justify-content: space-between; // 核心：左右两端对齐
  flex-wrap: nowrap; // 禁止换行，保证标签和序列号同行
  // PC端调整对齐方式
  @media (min-width: 768px) {
    align-items: center;
    min-height: 40px;
  }
}

.label-value-wrap {
  display: flex;
  align-items: center;
  flex-shrink: 1;
  // PC端适配
  @media (min-width: 768px) {
    max-width: calc(100% - 120px);
  }
}

// 操作标签样式（去绑定/重新绑定）
.bind-tag {
  font-size: 14px;
  line-height: 20px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  cursor: pointer;
  // PC端标签优化
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    padding: 4px 12px;
    margin-left: 15px;
    border-radius: 6px;
    // PC端hover效果
    &:hover {
      background: #B8860B !important;
      color: #000 !important;
      transform: scale(1.05);
      transition: all 0.2s ease;
    }
  }
}

// 状态标签-红色（待绑定/其他）
.bind-tag-red{
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: red;
  border: 1px solid red;
  border-radius: 15px;
  // PC端状态标签优化
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

// 状态标签-绿色（已绑定/绑定失败）
.bind-tag-green{
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: green;
  border: 1px solid green;
  border-radius: 15px;
  // PC端状态标签优化
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

// 新增：添加新球杆按钮样式
.add-club-btn-wrapper {
  margin: 15px 15px 15px;
  text-align: center;

  @media (min-width: 768px) {
    margin: 40px 20px 20px;
  }
}

.add-club-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  width: 100%;

  // PC端按钮样式优化
  @media (min-width: 768px) {
    font-size: 18px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    max-width: 500px;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 16px rgba(212, 175, 55, 0.4);
    }
  }

  // 覆盖vant默认样式
  ::v-deep &.van-button--primary {
    background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%) !important;
  }
}
</style>